document.addEventListener("DOMContentLoaded",()=>{

const dropdown=document.querySelector(".country-dropdown");

if(!dropdown) return;

const btn=dropdown.querySelector(".country-btn");

const menu=dropdown.querySelector(".country-menu");

const search=document.getElementById("countrySearch");

btn.onclick=()=>{

dropdown.classList.toggle("active");

};

document.addEventListener("click",(e)=>{

if(!dropdown.contains(e.target)){

dropdown.classList.remove("active");

}

});

search.addEventListener("keyup",function(){

let value=this.value.toLowerCase();

document.querySelectorAll(".country-option").forEach(item=>{

item.style.display=item.innerText.toLowerCase().includes(value)
?"block":"none";

});

});

});